export default "__VITE_ASSET__DOe9hXFE__"